import XLSX from 'xlsx';
import html2pdf from 'html2pdf.js'

export default {
    methods: {
        serviciosMultiples() {
            return this.dataMultiple.afiliacion_pendientes.multiple_servicios.filter(list => list.name !== 'Afp' && list.name !== 'Eps' && list.name !== 'Ccf' && list.name !== 'Riesgo' && list.name !== 'Administración' && list.name !== 'Traslado')
        },
        filterSelects(list) {
            return _.filter(this.lists[list], ['id_list_estado', 1])
        },
        async getLimpiar() {
            this.filter = {
                name: null,
                id_list: null,
                id_datos_razon: null,
                id_datos_asesor: null,
                id_datos_contacto: null,
            }
            this.mes = this.gettersDatalist('list_mes', this.fecha().fecha.mesHoy)[0]
            this.ano = this.gettersDatalist('list_ano', this.fecha().fecha.anoHoy)[0]
                // frontend await this.searchGetIdb({tabla:'afiliacion_registro', campo:'id_datos_asesor', value: this.filter.servicios.id})
        },
        async openPdf() {
            this.statusDescargar = false
            this.statusLoading = true
            let dataRoute = {}
            let others = []
            let filterKeys = Object.keys(this.filter);
            dataRoute.servicios = []
            var nameTitle = null
            for (let i = 0; i < filterKeys.length; i++) {
                if (this.filter[filterKeys[i]] !== '' && this.filter[filterKeys[i]] !== null) {
                    switch (filterKeys[i]) {
                        case 'name':
                            nameTitle = this.filter[filterKeys[i]].name
                            dataRoute.servicios.push([filterKeys[i], this.filter[filterKeys[i]].name])
                            break
                        default:
                            others.push([filterKeys[i], this.filter[filterKeys[i]].id])
                            break
                    }
                }
            }
            dataRoute.others = others
            dataRoute.mes = this.mes.id
            dataRoute.ano = this.ano.id
            let dataPostArray = await this.getData({ route: 'get_excelservicios', data: dataRoute })

            var html = '<div class="p-3">'

            html += '<h5 class="text-center m-2">LISTADO DE ' + nameTitle.toUpperCase() + ' </h5>'

            html += '<table class="table table-bordered table-sm table-pdf" ><thead class="thead-light"><tr> <th >#</th><th>Documento</th><th >Nombres</th><th >Contacto</th><th >Dirección</th><th >Teléfonos</th><th >Novedad</th><th >Periodo</th></tr></thead><tbody>'
            if (dataPostArray.length > 0) {
                for (let i = 0; i < dataPostArray.length; i++) {
                    let otrosExcell = ''
                    let valorExcell = 0
                    let otrosPeriodo = ''

                    if (dataPostArray[i].servicios_activos !== undefined) {
                        for (let j = 0; j < dataPostArray[i].servicios_activos.length; j++) {
                            valorExcell = valorExcell + dataPostArray[i].servicios_activos[j].valor
                            otrosExcell = dataPostArray[i].servicios_activos[j].name
                            otrosPeriodo = dataPostArray[i].servicios_activos[j].mes_periodo + '-' + dataPostArray[i].servicios_activos[j].ano_periodo
                        }
                    }
                    if (dataPostArray[i].servicios_nuevos !== undefined) {
                        for (let j = 0; j < dataPostArray[i].servicios_nuevos.length; j++) {
                            if (!otrosExcell.includes(dataPostArray[i].servicios_nuevos[j].name)) {
                                otrosExcell = dataPostArray[i].servicios_nuevos[j].name
                                otrosPeriodo = dataPostArray[i].servicios_nuevos[j].mes_periodo + '-' + dataPostArray[i].servicios_nuevos[j].ano_periodo
                                valorExcell = valorExcell + dataPostArray[i].servicios_nuevos[j].valor
                            }
                        }
                    }
                    if (dataPostArray[i].direccion === null) { dataPostArray[i].direccion = '' }
                    if (dataPostArray[i].telefonos === null) { dataPostArray[i].telefonos = '' }

                    html += '<tr>'
                    html += '<td>' + (i + 1) + '</td>'
                    html += '<td>' + this.gettersDatalist('list_documento', dataPostArray[i].id_list_documento)[0].name + ' ' + dataPostArray[i].documento + '</td>'
                    html += '<td class="text-uppercase">' + dataPostArray[i].name + '</td>'
                    html += '<td class="text-uppercase">' + this.gettersDatalist('datos_contacto', dataPostArray[i].id_datos_contacto)[0].name + '</td>'
                    html += '<td class="text-uppercase">' + dataPostArray[i].direccion + '</td>'
                    html += '<td class="text-uppercase">' + dataPostArray[i].telefonos + '</td>'
                    html += '<td class="text-uppercase">' + dataPostArray[i].novedad + '</td>'
                    html += '<td class="text-uppercase">' + otrosPeriodo + '</td>'
                    html += '</tr>'
                }
            }
            html += '</tbody></table></div>'
            const options = {
                margin: 0.2,
                filename: 'listado.pdf',
                image: { type: 'jpeg', quality: 0.8 },
                pagebreak: { mode: ['avoid-all'] },
                html2canvas: { scale: 1 },
                jsPDF: {
                    unit: 'in',
                    format: 'letter',
                    orientation: 'portrait'
                }
            };
            if (dataPostArray.length > 400) {
                await html2pdf(html, options)
            } else {
                await html2pdf().set(options).from(html).outputPdf('dataurlnewwindow');
            }

            this.statusLoading = false
            return true
        },
        async openExcell() {
            this.statusDescargar = false
            this.statusLoading = true
            let dataRoute = {}
            let others = []
            let filterKeys = Object.keys(this.filter);
            dataRoute.servicios = []
            for (let i = 0; i < filterKeys.length; i++) {
                if (this.filter[filterKeys[i]] !== '' && this.filter[filterKeys[i]] !== null) {
                    switch (filterKeys[i]) {
                        case 'name':
                            dataRoute.servicios.push([filterKeys[i], this.filter[filterKeys[i]].name])
                            break
                        default:
                            others.push([filterKeys[i], this.filter[filterKeys[i]].id])
                            break
                    }
                }
            }
            dataRoute.others = others
            dataRoute.mes = this.mes.id
            dataRoute.ano = this.ano.id
            let dataPostArray = await this.getData({ route: 'get_excelservicios', data: dataRoute })
            this.statusLoading = false
            let dataToExport = []
            if (dataPostArray.length > 0) {
                for (let i = 0; i < dataPostArray.length; i++) {
                    let otrosExcell = ''
                    let valorExcell = 0
                    let otrosPeriodo = ''

                    if (dataPostArray[i].servicios_activos !== undefined) {
                        for (let j = 0; j < dataPostArray[i].servicios_activos.length; j++) {
                            valorExcell = valorExcell + dataPostArray[i].servicios_activos[j].valor
                            otrosExcell = dataPostArray[i].servicios_activos[j].name
                            otrosPeriodo = dataPostArray[i].servicios_activos[j].mes_periodo + '-' + dataPostArray[i].servicios_activos[j].ano_periodo
                        }
                    }
                    if (dataPostArray[i].servicios_nuevos !== undefined) {
                        for (let j = 0; j < dataPostArray[i].servicios_nuevos.length; j++) {
                            if (!otrosExcell.includes(dataPostArray[i].servicios_nuevos[j].name)) {
                                otrosExcell = dataPostArray[i].servicios_nuevos[j].name
                                otrosPeriodo = dataPostArray[i].servicios_nuevos[j].mes_periodo + '-' + dataPostArray[i].servicios_nuevos[j].ano_periodo
                                valorExcell = valorExcell + dataPostArray[i].servicios_nuevos[j].valor
                            }
                        }
                    }
                    let datosrazon = this.gettersDatalist('datos_razon', dataPostArray[i].id_datos_razon)[0]
                    dataToExport.push([datosrazon.name.toUpperCase(), dataPostArray[i].novedad, this.gettersDatalist('list_documento', dataPostArray[i].id_list_documento)[0].name, dataPostArray[i].documento.toString(), dataPostArray[i].nombre1.toUpperCase(), (dataPostArray[i].nombre2 === null) ? dataPostArray[i].nombre2 : dataPostArray[i].nombre2.toUpperCase(), dataPostArray[i].apellido1.toUpperCase(), (dataPostArray[i].apellido2 === null) ? dataPostArray[i].apellido2 : dataPostArray[i].apellido2.toUpperCase(), dataPostArray[i].nacimiento, (dataPostArray[i].direccion === null) ? dataPostArray[i].direccion : dataPostArray[i].direccion.toUpperCase(), (dataPostArray[i].ciudad === null) ? dataPostArray[i].ciudad : dataPostArray[i].ciudad.toUpperCase(), dataPostArray[i].telefonos, (dataPostArray[i].email === null) ? dataPostArray[i].email : dataPostArray[i].email.toUpperCase(), this.gettersDatalist('datos_contacto', dataPostArray[i].id_datos_contacto)[0].name.toUpperCase(), this.gettersDatalist('datos_asesor', dataPostArray[i].id_datos_asesor)[0].name.toUpperCase(), dataPostArray[i].ingreso, otrosExcell.toUpperCase(), valorExcell, otrosPeriodo])
                }

                let datae = XLSX.utils.json_to_sheet(dataToExport)

                datae['A1'].v = 'Razon Social'
                datae['B1'].v = 'Novedad'
                datae['C1'].v = 'Tipo'
                datae['D1'].v = 'Documento'
                datae['E1'].v = 'Nombre1'
                datae['F1'].v = 'Nombre2'
                datae['G1'].v = 'Apellido1'
                datae['H1'].v = 'Apellido2'
                datae['I1'].v = 'Nacimiento'
                datae['J1'].v = 'Dirección'
                datae['K1'].v = 'Ciudad'
                datae['L1'].v = 'Telefonos'
                datae['M1'].v = 'Email'
                datae['N1'].v = 'Centro Trabajo'
                datae['O1'].v = 'Asesor'
                datae['P1'].v = 'Inicio Labores.'
                datae['Q1'].v = 'Servicios'
                datae['R1'].v = 'Total'
                datae['S1'].v = 'Periodo'
                const workbook = XLSX.utils.book_new()
                const filename = 'listado' + this.fecha().fecha.hoy
                XLSX.utils.book_append_sheet(workbook, datae, filename)
                XLSX.writeFile(workbook, `${filename}.xlsx`)
            } else {
                this.statusDescargar = true
            }
        },
    },
}